import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

function Vi(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="createdocs">
                1.&nbsp;<span className="material-symbols-outlined">assignment_add</span>&nbsp;{translate('createdocs')}
            </Typography>
            <p><strong>{translate('createdocs')}</strong> là một hành tạo Google Documents.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này.</td>
                                <td>$newDocs_1</td>
                            </tr>
                            <tr>
                                <td>{translate('providerid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là <strong>Provider ID</strong> của kết nối Google Docs được sử dụng để xác định tài khoản Google Docs (xem <Box component={Link} to="/control-center/documentation/connections/docs">tại đây</Box> để biết cách tạo kết nối).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('title')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là tiêu đề Documents.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="object" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$newDocs_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('providerid')}</span>
                            <div>gdocs-1a2b3c4d5e6g7h</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('title')}</span>
                            <div>New Document</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                    {
                                        "title": "New Document",
                                        "body": {
                                            "content": [
                                            {
                                                "startIndex": 1,
                                                "endIndex": 7,
                                                "paragraph": {
                                                "elements": [
                                                    {
                                                    "startIndex": 1,
                                                    "endIndex": 7,
                                                    "textRun": {
                                                        "content": "",
                                                        "textStyle": {}
                                                    }
                                                    }
                                                ],
                                                }
                                            },
                                            ]
                                        },
                                        "documentStyle": {
                                        },
                                        "namedStyles": {
                                        },
                                        "revisionId": "ALm37BX3DsadsGMuNKSYIlwjyi6ZScCWIAPqnrnlbHQAgBtu3HgsPe8WW4k58qoeq5-YrVd4cYtfTaMozZrYKQ",
                                        "suggestionsViewMode": "SUGGESTIONS_INLINE",
                                        "documentId": "1nSSBzMkrr4QbnQKq3QR7GCdnWqkRT_l68FkcMwe8pM4",
                                        "providerID": "gdocs-1a2b3c4d5e6g7h",
                                        "paragraphCount": 5
                                    }, null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="getdocs">
                2.&nbsp;<span className="material-symbols-outlined">assignment</span>&nbsp;{translate('getdocs')}
            </Typography>
            <p><strong>{translate('getdocs')}</strong> là một hành động truy xuất một đối tượng Google Documents.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này.</td>
                                <td>$docs_1</td>
                            </tr>
                            <tr>
                                <td>{translate('providerid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là <strong>Provider ID</strong> của kết nối Google Docs được sử dụng để xác định tài khoản Google Docs (xem <Box component={Link} to="/control-center/documentation/connections/docs">tại đây</Box> để biết cách tạo kết nối).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('documentid')}<span>*</span></td>
                                <td>
                                <ParametersTypeValue type="text" />
                                </td>
                                <td>Là ID hoặc URL của tệp bạn muốn truy xuất.</td>
                                <td></td>
                            </tr>
                            
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="object" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                    <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$docs_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('providerid')}</span>
                            <div>gdocs-1a2b3c4d5e6g7h</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('documentid')}</span>
                            <div>1zTG_XHbCnC5a5BD5k5WWxdbcYpnEDv4_FfdAPaE33ro</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        {
                                            "title": "New Document",
                                            "body": {
                                                "content": [
                                                {
                                                    "startIndex": 0,
                                                    "endIndex": 0,
                                                    "paragraph": {
                                                    "elements": [
                                                        {
                                                        "startIndex": 0,
                                                        "endIndex": 0,
                                                        "textRun": {
                                                            "content": "",
                                                            "textStyle": {}
                                                        }
                                                        }
                                                    ],
                                                    }
                                                },
                                                ]
                                            },
                                            "documentStyle": {
                                            },
                                            "namedStyles": {
                                            },
                                            "revisionId": "ALm37BX3DsadsGMuNKSYIlwjyi6ZScCWIAPqnrnlbHQAgBtu3HgsPe8WW4k58qoeq5-YrVd4cYtfTaMozZrYKQ",
                                            "suggestionsViewMode": "SUGGESTIONS_INLINE",
                                            "documentId": "1nSSBzMkrr4QbnQKq3QR7GCdnWqkRT_l68FkcMwe8pM4",
                                            "providerID": "gdocs-1a2b3c4d5e6g7h",
                                            "paragraphCount": 0
                                        }, null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="docsinsertparagraph">
                3.&nbsp;<span className="material-symbols-outlined">note_alt</span>&nbsp;{translate('docsinsertparagraph')}
            </Typography>
            <p><strong>{translate('docsinsertparagraph')}</strong> là một hành động chèn văn bản vào đoạn được chỉ định trong Google Documents.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này.</td>
                                <td>$docsInsertParagraph_1</td>
                            </tr>
                            <tr>
                                <td>{translate('providerid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là <strong>Provider ID</strong> của kết nối Google Docs được sử dụng để xác định tài khoản Google Docs (xem <Box component={Link} to="/control-center/documentation/connections/docs">tại đây</Box> để biết cách tạo kết nối).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                <ParametersTypeValue type="text" />
                                </td>
                                <td>Là văn bản dùng để chèn vào Google Documents.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('index')}<span>*</span></td>
                                <td>
                                <ParametersTypeValue type="text" />
                                </td>
                                <td>Là các vị trí chỉ mục được chỉ định trong phần nội dung của Google Documents.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="object" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                    <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$docsInsertParagraph_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('providerid')}</span>
                            <div>gdocs-1a2b3c4d5e6g7h</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('text')}</span>
                            <div>Hello</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('index')}</span>
                            <div>0</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        {
                                            "title": "New Document",
                                            "body": {
                                                "content": [
                                                {
                                                    "startIndex": 0,
                                                    "endIndex": 5,
                                                    "paragraph": {
                                                    "elements": [
                                                        {
                                                        "startIndex": 1,
                                                        "endIndex": 7,
                                                        "textRun": {
                                                            "content": "Hello",
                                                            "textStyle": {}
                                                        }
                                                        }
                                                    ],
                                                    }
                                                }
                                                ]
                                            },
                                            "documentStyle": {
                                            },
                                            "namedStyles": {
                                            },
                                            "revisionId": "ALm37BX3DsadsGMuNKSYIlwjyi6ZScCWIAPqnrnlbHQAgBtu3HgsPe8WW4k58qoeq5-YrVd4cYtfTaMozZrYKQ",
                                            "suggestionsViewMode": "SUGGESTIONS_INLINE",
                                            "documentId": "1nSSBzMkrr4QbnQKq3QR7GCdnWqkRT_l68FkcMwe8pM4",
                                            "providerID": "gdocs-1a2b3c4d5e6g7h",
                                            "paragraphCount": 5
                                            }, null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </Box>
    );
}
export default withTranslate(Vi);